import swedenFlag from '@sweetspot/club-portal-legacy/resources/images/sweden.png'
import ukFlag from '@sweetspot/club-portal-legacy/resources/images/united_kingdom.png'
import { LanguageOption } from './types'

export const LANGUAGE_OPTIONS: LanguageOption[] = [
  { name: 'English', value: 'en', flag: ukFlag },
  { name: 'Svenska', value: 'sv', flag: swedenFlag },
]
